export { default } from './WelcomeMessageBuilder'


// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/index.js